<template>
    <label class="flex items-center gap-2 cursor-pointer select-none min-h-[40px] w-full" @click.prevent="toggle">
        <span
            class="w-5 h-5 rounded border-2 flex items-center justify-center transition-colors flex-shrink-0"
            :class="isChecked() ? 'bg-primary border-primary' : 'border-white/40'"
        >
            <svg v-if="isChecked()" class="w-4 h-4 text-primary-fg" viewBox="0 0 20 20" fill="currentColor">
                <path
                    d="M16.7 5.3a1 1 0 010 1.4l-7 7a1 1 0 01-1.4 0l-3.5-3.5a1 1 0 111.4-1.4L9 11.6l6.3-6.3a1 1 0 011.4 0z"
                />
            </svg>
        </span>
        <span v-if="label" class="flex-1">{{ label }}</span>
        <slot />
    </label>
</template>

<script setup lang="ts">
    const props = defineProps<{
        modelValue: boolean | unknown[]
        value?: unknown
        label?: string
    }>()

    const emit = defineEmits<{
        'update:modelValue': [value: boolean | unknown[]]
    }>()

    function toggle() {
        if (Array.isArray(props.modelValue)) {
            if (props.value === undefined) return
            const arr = props.modelValue
            const idx = arr.indexOf(props.value)
            if (idx >= 0) {
                emit(
                    'update:modelValue',
                    arr.filter((_, i) => i !== idx)
                )
            } else {
                emit('update:modelValue', [...arr, props.value])
            }
        } else {
            emit('update:modelValue', !props.modelValue)
        }
    }

    function isChecked(): boolean {
        if (Array.isArray(props.modelValue)) {
            return props.value !== undefined && props.modelValue.includes(props.value)
        }
        return Boolean(props.modelValue)
    }
</script>
